import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { InterntPackageTypeApi } from '../../services/api/InternetPackage';
import {
    FetchError,
    SetInternetPackage,
    FetchInternetPackage,
    FetchModal
} from "./actions"
import { InternetPackageActionTypes } from './types'

function* handleInternetPackageTypes(action: ReturnType<typeof FetchInternetPackage>) {
    // @ts-ignore
    const res = yield call(() => InterntPackageTypeApi(action.payload));
    if (res) {
        console.log(res, 'res')
        yield put(SetInternetPackage(res))
        yield put(FetchModal(true))
    } else {
        console.log('error')
        yield put(FetchModal(false))
        yield put(FetchError())
    }
}

function* watchInternetPackageTypes() {
    console.log('watch internet package type');

    yield takeLatest(InternetPackageActionTypes.FETCH_INTERNET_PACKAGE_TYPES, handleInternetPackageTypes)
}

function* internetPackageSaga() {
    yield all([
        fork(watchInternetPackageTypes),
    ])
}

export default internetPackageSaga